import React, { useEffect, useState } from "react";
import ProductList from "../../components/AdvanceDynamicList/ProductList";
import { getStoredData } from "../../json/fecthData";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";
import { getUser, hasPermission } from "../../pages/Login/authUtils";

const MasterTrackerPanel = () => {
  const data = getStoredData()?.[1] || {};

  const TitleMasterTracker = data.TitleMasterTracker || "Master Tracker";
  const AdminMasterTracker = data.AdminMasterTracker || [];
  const RedirectAdminMasterTracker = data.RedirectAdminMasterTracker;
  const ApiMasterTracker = data.ApiMasterTracker;
  const roleCompare = data.roleCompare || [];
  const StatusMasterTracker = data.MasterTrackerStatus || [];

  const { apiData } = useApiData(["tracker"]);
  const [masterTrackerItems, setMasterTrackerItems] = useState([]);

  const canDelete = hasPermission("tracker:delete");
  const canUpload = hasPermission("tracker:upload");
  const canDownload = hasPermission("tracker:download");

  const user = getUser();

  useEffect(() => {
    if (Array.isArray(apiData?.tracker)) {
      setMasterTrackerItems(apiData.tracker);
    }
  }, [apiData?.tracker]);

  return (
    <div className="MasterTrackerPanel">
      <h1>{TitleMasterTracker} Management</h1>
      <ProductList
        products={masterTrackerItems}
        setProducts={setMasterTrackerItems}
        fields={AdminMasterTracker}
        redirect={RedirectAdminMasterTracker}
        deleteApi={ApiMasterTracker}
        roleCompare={roleCompare}
        createPath={hasPermission("MasterTracker:create") ? "/tracker/create" : null}
        showDelete={canDelete}
        showUpload={canUpload}
        showDownload={canDownload}
        status={StatusMasterTracker}
        title={TitleMasterTracker}
      />
    </div>
  );
};

export default MasterTrackerPanel;
